import GridItem from 'components/Grid/GridItem';
import { Caption, HeadingMBold, HeadingSBold } from 'components/Typography/Typography';
import { translate } from 'components/Translation';
import Card from 'components/Card/Card';
import CardBody from 'components/Card/CardBody';
import Button from 'components/CustomButtons/Button';
import GridContainer from 'components/Grid/GridContainer';
import React from 'react';
import styles from 'assets/jss/material-dashboard-pro-react/views/numberDetails/usageStyle';
import { makeStyles } from '@material-ui/core';
import Icons from 'views/Numbers/Details/Usage/common/Icons';
import BundleLeft from 'views/Numbers/Details/Usage/common/BundleLeft';
import { useHistory } from 'react-router';
import { cardsUsage } from 'views/Numbers/Details/Usage/common/ShowPermission';
import { Total } from 'utils/api/models/numbers/usage';
import ConditionalRender from 'components/ConditionalRender/ConditionalRender';

// @ts-ignore
const useStyles = makeStyles(styles);

interface ICurrentUsageProps {
	accountType: string;
	billingType: string;
	totals: Total[];
	url: string;
}

const CurrentUsage = ({ accountType, billingType, totals, url }: ICurrentUsageProps) => {
	const classes = useStyles();
	const history = useHistory();

	const showList = cardsUsage[accountType.toLowerCase()][billingType.toLowerCase()];

	const searchBundle = (type: string): Total | undefined => {
		return totals.find((element: Total) => element.type === type && element.group === 'GENERAL');
	};

	const bundles = {
		sms: searchBundle('SMS'),
		data: searchBundle('DATA'),
		voice: searchBundle('VOICE'),
	};

	const usageCards: types.usage.IUsageCard[] = showList.map((type: string) => ({
		icon: Icons(type, 'general'),
		name: `numbers.usage.${type}`,
		Usage:
			accountType.toLowerCase() === 'internet' ? (
				<div>
					<Caption>{translate('numbers.usage.totalTransfer')}</Caption>
					<ConditionalRender
						show={!!bundles[type]}
						onTrue={() => (
							<HeadingMBold disableMargin>
								<>
									{bundles[type]?.balance?.value} {bundles[type]?.balance?.unit}
								</>
							</HeadingMBold>
						)}
						onFalse={() => <HeadingMBold disableMargin>-</HeadingMBold>}
					/>
				</div>
			) : (
				<BundleLeft
					header={translate(`numbers.usage.${type}Left`)}
					data={bundles[type]}
					hideUnit={type !== 'data'}
					noPackageText={translate(`numbers.usage.${type}NoPackage`)}
					unlimitedText={translate(`numbers.usage.${type}Unlimited`)}
				/>
			),
		data: !!bundles[type],
		onClick: () => history.push(`${url}/details/${type}`),
	}));

	return (
		<GridContainer justify="flex-start" id="usage-cards">
			<GridItem xs={12}>
				<HeadingMBold color="secondary-light">{translate('numbers.usage.currentUsage')}</HeadingMBold>
			</GridItem>
			<>
				{usageCards.map(({ name, icon, Usage, data, onClick }) => (
					<GridItem key={name} xs={12} lg={4}>
						<Card raised className={classes.usageCard}>
							<>
								<CardBody>
									<HeadingSBold disableMargin>{translate(name)}</HeadingSBold>
									<div className={classes.totalCardContainer}>
										<div className={classes.totalCardIcon}>
											<img src={icon} alt="" />
										</div>
										<div className={classes.totalCardUsage}>{Usage}</div>
									</div>
								</CardBody>
								<ConditionalRender
									show={data}
									onTrue={() => (
										<Button
											color="tertiary-light"
											className={classes.showDetailsButton}
											onClick={onClick}
										>
											{translate('numbers.usage.showDetails')}
										</Button>
									)}
								/>
							</>
						</Card>
					</GridItem>
				))}
			</>
		</GridContainer>
	);
};

export default CurrentUsage;
